import { API_URL } from "../constants";

/** @param {unknown} value */
const recordOrNull = (value) =>
  value && typeof value === "object" && !Array.isArray(value)
    ? /** @type {Record<string, any>} */ (value)
    : null;

/** @param {unknown} url */
export const absoluteVideoUrl = (url) => {
  if (typeof url !== "string" || !url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  return `${API_URL}${url.startsWith("/") ? "" : "/"}${url}`;
};

/**
 * Public report JSON exposes only an approved/current video. Still fail closed
 * if a nested preview carries any other state. A direct top-level `video`
 * object is treated as the server's approved-only public projection.
 * @param {Record<string, any> | null | undefined} doc
 */
export const publicApprovedVideoPreview = (doc) => {
  const directVideo = recordOrNull(doc?.video);
  const envelope = recordOrNull(doc?.video_preview);
  const nestedPreview = recordOrNull(envelope?.preview) || envelope;
  let preview = null;
  let finalVideo = null;

  if (directVideo) {
    const directStatus =
      typeof directVideo.status === "string" ? directVideo.status.toLowerCase() : "approved";
    if (directStatus !== "approved" || directVideo.is_stale === true) return null;
    preview = directVideo;
    finalVideo = recordOrNull(directVideo.final_video) || directVideo;
  } else if (nestedPreview) {
    const nestedStatus =
      typeof nestedPreview.status === "string" ? nestedPreview.status.toLowerCase() : "";
    if (nestedStatus !== "approved" || nestedPreview.is_stale === true) return null;
    preview = nestedPreview;
    finalVideo = recordOrNull(nestedPreview.final_video);
  }

  if (!preview || finalVideo?.available !== true || !finalVideo.play_url) return null;
  return {
    ...preview,
    status: "approved",
    is_stale: false,
    final_video: {
      ...finalVideo,
      play_url: absoluteVideoUrl(finalVideo.play_url),
      download_url: absoluteVideoUrl(finalVideo.download_url),
    },
  };
};
